const commissionedSoftphones = new Set([
  "d44eb7c0-ae99-48ab-afb7-0bb12c978447",
  "04e7c7fd-36bf-4e2b-a387-c67289c2c6de",
]);

export function isSoftphoneEquipment(device: {
  id?: string;
  equipment_kind?: string;
}) {
  // The two commissioned softphones predate the dedicated equipment kind.
  return (
    device.equipment_kind === "softphone" ||
    (typeof device.id === "string" && commissionedSoftphones.has(device.id))
  );
}
